 
import { useCallback, useEffect, useRef, useState } from 'react'
import './doseDurationView.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PrimaryButton, Dropdown, InputText } from 'ui_kit_qmd'
import classNames from 'classnames'
import ReactSwitch from 'react-switch'
import { buttonStyle } from '../../utils'
import { type CartItem, type DrugOption } from '../../../../types/products/productTypes'
import { useProductOrderContext } from '../../context'
import { useGetOrderNameFromProduct } from 'components/product-order-popup/hooks/useGetOrderNameFromProduct'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { v4 as uuidv4 } from 'uuid'
import { HeaderView } from '../header-view/HeaderView'

const Switch = ReactSwitch as any

interface Props {
  title: string
  onConfirmDoseHandler: () => void
}

export const DoseDurationView = ({ title, onConfirmDoseHandler }: Props) => {
  const {
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    setOrderInfo,
    orderInfo,
    selectedOption,
    product,
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    category,
    setCartItems,
    editCartItemId,
    refillsQuantity,
    isMHT,
    isMoudHomeDelivery,
  } = useProductOrderContext()
  const { getOrderNameFromProduct } = useGetOrderNameFromProduct({ isMoudHomeDelivery })
  const durationDropdownKey = useRef('')
  const durationValueRef = useRef(undefined)
  const doseSelected = useRef<DrugOption | undefined>(undefined)
  const order = useRef<{ totalText: string; typeText: string; infoText: string; total: number } | undefined>()
  const prevSigValue = useRef('')
  const doseOptions = useRef(selectedOption?.DrugOptions.map((drugOption) => drugOption.DrugOption))
  const [durationDropdownOptions, setDurationDropdownOptions] = useState([])
  const [sigValue, setSigValue] = useState('')
  const [durationValue, setDurationValue] = useState('')
  const [doseValue, setDoseValue] = useState('')
  const [substitutionAllowed, setSubstitutionAllowed] = useState(() => {
    const isBrandedProduct = [product?.Brand, product?.Variation].filter(Boolean).some((x) => /branded/i.test(x))
    return !isBrandedProduct
  })

  useEffect(() => {
    if (isMHT) {
      // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
      const days = selectedOption.DurationDays
      const options = [
        <div
          role='presentation'
          data-days={days}
          data-value={days}
          data-total={days}
          className={classNames('duration-dropdown-row')}>
          <div className={classNames('duration-dropdown-days')}>{`${days} days`}</div>
          <div className={classNames('duration-dropdown-left-container')}>
            {`${days} ${selectedOption?.DispenseUnits}s`}
          </div>
        </div>,
      ]
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setDurationDropdownOptions(options)
      onSetDuration(options[0])

      durationDropdownKey.current = 'mht'
    }
  }, [])
  const onSetDose = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setDoseValue(value)
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      durationValueRef.current = ''
      setDurationValue('')
      doseSelected.current = selectedOption?.DrugOptions.find((item) => item.DrugOption === value)
      const options = []
      order.current = undefined
      for (let i = 3; i <= 30; i++) {
        // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
        const total = doseSelected.current.Quantity * i
        options.push(
          <div
            role='presentation'
            data-days={i}
            data-value={value}
            data-total={total}
            className={classNames('duration-dropdown-row')}>
            <div className={classNames('duration-dropdown-days')}>{`${i} days`}</div>
            <div className={classNames('duration-dropdown-left-container')}>
              {`${total} ${selectedOption?.DispenseUnits}s`}
            </div>
          </div>,
        )
      }
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setDurationDropdownOptions(options)
      if (prevSigValue.current === sigValue) {
        setSigValue('')
        prevSigValue.current = ''
      }
      durationDropdownKey.current = value
    },
    [selectedOption?.DispenseUnits, selectedOption?.DrugOptions, sigValue],
  )
  const addToCart = useCallback(
    (orderItem: CartItem) => {
      setCartItems([orderItem])
    },
    [setCartItems],
  )

  const confirmDose = useCallback(() => {
    if (editCartItemId) {
      setCartItems((prev) => {
        const position = prev.findIndex((cartItem) => cartItem.CartId === editCartItemId)
        prev[position] = {
          ...orderInfo,
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          Order: {
            ...selectedOption,
            Name: getOrderNameFromProduct(product),
          },
          RefillsQuantity: refillsQuantity ?? 0,
          DosageQuantity: doseSelected.current?.Quantity,
          // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
          OptionId: selectedOption.OptionId,
          // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
          ProductId: product.ProductId,
          CartId: editCartItemId,
          Signature: sigValue,
          IsSubstitutionAllowed: substitutionAllowed,
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          DurationDays: durationValueRef.current,
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          DrugOptionId: doseSelected.current?.DrugOptionId,
          // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
          DispenseAmount: order.current.total,
          EarliestFillDate: undefined,
          // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
          IsControlledSubstance: product.IsControlledSubstance,
        }
        return prev
      })
    } else {
      addToCart({
        ...orderInfo,
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        Order: {
          ...selectedOption,
          Name: getOrderNameFromProduct(product),
        },
        RefillsQuantity: refillsQuantity ?? 0,
        DosageQuantity: doseSelected.current?.Quantity,
        // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
        OptionId: selectedOption.OptionId,
        // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
        ProductId: product.ProductId,
        CartId: uuidv4(),
        Signature: sigValue,
        IsSubstitutionAllowed: substitutionAllowed,
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        DurationDays: durationValueRef.current,
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        DrugOptionId: doseSelected.current?.DrugOptionId,
        // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
        DispenseAmount: order.current.total,
        EarliestFillDate: undefined,
        // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
        IsControlledSubstance: product.IsControlledSubstance,
      })
    }

    onConfirmDoseHandler()
  }, [
    addToCart,
    editCartItemId,
    getOrderNameFromProduct,
    onConfirmDoseHandler,
    orderInfo,
    product,
    refillsQuantity,
    selectedOption,
    setCartItems,
    sigValue,
    substitutionAllowed,
  ])
  const onSetDuration = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      console.log(value.props['data-days'])
      durationValueRef.current = value.props['data-days']
      setDurationValue(`${value.props['data-days']} days`)
      setTimeout(() => {
        const element = document.getElementById('title')
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        element.click()
      }, 100)
      const total = value.props['data-total']
      const isFraction = !Number.isInteger(total)

      order.current = {
        totalText: `${Math.ceil(total)} ${selectedOption?.DispenseUnits}s`,
        typeText: ` of ${title} - ${selectedOption?.ShortName}`,
        infoText: isFraction ? `Rounded from ${total} to ${Math.ceil(total)}` : '',
        total: Math.ceil(total),
      }
      if (isMHT) {
        // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
        setSigValue(selectedOption.Signature)
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        prevSigValue.current = selectedOption.Signature
      } else if (sigValue === '' || sigValue === prevSigValue.current) {
        const sig = `${value.props['data-value']} for ${value.props['data-days']} days`
        setSigValue(sig)
        prevSigValue.current = sig
      }
    },
    [selectedOption?.DispenseUnits, selectedOption?.ShortName, sigValue, title],
  )

  useEffect(() => {
    const dose = orderInfo?.DrugOptionId
    if (dose) {
      const duration = orderInfo.DurationDays
      const signature = orderInfo.Signature
      doseSelected.current = selectedOption?.DrugOptions.find((item) => item.DrugOptionId === dose)
      onSetDose(doseSelected.current?.DrugOption)
      setDurationValue(`${duration} days`)
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      durationValueRef.current = duration
      setTimeout(() => {
        const element = document.getElementById('title')
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        element.click()
      }, 100)
      // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
      const sig = signature || `${doseSelected.current.DrugOption} for ${duration} days`
      setSigValue(sig)
      prevSigValue.current = sig
      // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
      const total = doseSelected.current.Quantity * duration
      const isFraction = !Number.isInteger(total)

      order.current = {
        totalText: `${Math.ceil(total)} ${selectedOption?.DispenseUnits}${selectedOption?.DispenseUnits.charAt((selectedOption?.DispenseUnits.length || 1) - 1) === 's' ? '' : 's'}`,
        typeText: ` of ${title} - ${selectedOption?.ShortName}`,
        infoText: isFraction ? `Rounded from ${total} to ${Math.ceil(total)}` : '',
        total: Math.ceil(total),
      }
    }
  }, [])
  return (
    <div className='dose-duration-container'>
      <HeaderView title={title} />
      <div className='dose-duration-body-container'>
        <div className='dose-duration-section-text'>Select daily dose and duration</div>
        {!isMHT && (
          <Dropdown
            dropId='dose-dropdown-'
            options={doseOptions.current}
            containerStyle={{ width: '100%' }}
            label='Daily dose*'
            setValue={onSetDose}
            value={doseValue}
          />
        )}
        <Dropdown
          key={durationDropdownKey.current}
          fullInputControl
          isDisabled={durationDropdownOptions.length === 0 && !isMHT}
          dropId='duration-dropdown-'
          options={durationDropdownOptions}
          containerStyle={{ width: '100%' }}
          label='Duration*'
          setValue={onSetDuration}
          value={durationValue}
        />
        <InputText
          disabled={durationValueRef.current === undefined}
          label='Sig*'
          containerStyle={{ width: '100%' }}
          view='visitType'
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          setValue={(value) => {
            setSigValue(value)
          }}
          value={sigValue}
        />
        <div className='dose-duration-section-text'>Order quantity</div>

        <div className='dose-duration-order-container'>
          <div className='order-text'>
            {order.current ?
              <>
                <div className='filled'>
                  <span className='bold'>{order.current.totalText}</span>
                  {order.current.typeText}
                </div>
                {order.current.infoText ?
                  <div className='info-text'>{order.current.infoText}</div>
                : null}
              </>
            : 'Please choose a daily dose and duration to calculate the order quantity'}
          </div>
        </div>

        {!isMHT && (
          <div className='dose-duration-switch-container'>
            <Switch
              onChange={setSubstitutionAllowed}
              checked={substitutionAllowed}
              offColor='#B0BDCB'
              onColor='#00A2B2'
              height={30}
              width={66}
              uncheckedIcon={<div className='dose-duration-switch-off-container'>off</div>}
              checkedIcon={<div className='dose-duration-switch-on-container'>on</div>}
              activeBoxShadow='#ffffff'
            />
            <div className='preferences-toggle-description'>Substitutes allowed</div>
          </div>
        )}
        <PrimaryButton
          useUpdatedStyle
          disabled={!durationValueRef.current}
          containerStyle={buttonStyle}
          btnText={
            isMHT ?
              editCartItemId ?
                'Edit item'
              : 'Add to order'
            : 'Continue'
          }
          onPress={confirmDose}
        />
      </div>
    </div>
  )
}
